/* FDP discount-link dropdown
   Shows a slide-down notice when a shopper arrives through a Shopify discount link
   (e.g. /discount/Welcome). Shopify sets the `discount_code` cookie and redirects,
   so we read that cookie on the landing page and tell the shopper the code will
   apply automatically at checkout. Shown once per code per browser session.
   Markup: snippets/fdp-discount-dropdown.liquid (rendered from layout/theme.liquid)
   Styles: compiled into sg-custom.css from 2_0-0-1custom-less/fdp-discount-dropdown.less */
(function(){
  try{
    var m=document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
    if(!m) return;
    var code=decodeURIComponent(m[1]).replace(/\+/g,' ').trim();
    if(!code) return;
    var key='fdp_dd_shown_'+code.toLowerCase();
    try{ if(sessionStorage.getItem(key)) return; }catch(e){}

    var root=document.getElementById('fdp-dd');
    if(!root) return;
    root.querySelector('[data-fdp-dd-code]').textContent=code;
    var timer, paused=false, remaining=12000, started;

    function close(){
      clearTimeout(timer);
      root.classList.remove('is-open');
      setTimeout(function(){ root.hidden=true; },450);
      document.removeEventListener('keydown',onKey);
      document.removeEventListener('pointerdown',onOutside,true);
    }
    function onKey(e){ if(e.key==='Escape') close(); }
    // Click/tap anywhere outside the card closes it
    // The first tap outside only dismisses the card; it doesn't also open whatever link was under it
    function swallowClick(e){ e.preventDefault(); e.stopPropagation(); document.removeEventListener('click',swallowClick,true); }
    function onOutside(e){
      var card=root.querySelector('.fdp-dd__card');
      if(card && !card.contains(e.target)){
        document.addEventListener('click',swallowClick,true);
        setTimeout(function(){ document.removeEventListener('click',swallowClick,true); },700);
        close();
      }
    }
    function arm(ms){ started=Date.now(); timer=setTimeout(close,ms); }

    root.querySelector('.fdp-dd__x').addEventListener('click',close);
    // Pause auto-close while the shopper is reading it
    root.addEventListener('mouseenter',function(){ if(!paused){ paused=true; clearTimeout(timer); remaining=Math.max(3000,remaining-(Date.now()-started)); } });
    root.addEventListener('mouseleave',function(){ if(paused){ paused=false; remaining=12000; arm(remaining); } });

    function open(){
      // mark as seen only once it actually shows (survives redirect/reload chains)
      try{ if(sessionStorage.getItem(key)) return; sessionStorage.setItem(key,'1'); }catch(e){}
      root.hidden=false;
      requestAnimationFrame(function(){ requestAnimationFrame(function(){ root.classList.add('is-open'); arm(remaining); document.addEventListener('keydown',onKey); document.addEventListener('pointerdown',onOutside,true); }); });
    }
    // Drop in shortly after the page renders (don't wait for every image/app to load)
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ setTimeout(open,800); });
    else setTimeout(open,800);
  }catch(e){}
})();
